import { z } from 'zod';
export const baseLabDrawSchema = z.object({
    // Per-tile present toggles
    labSpecimenPresent: z.boolean().optional(),
    bloodDrawPresent: z.boolean().optional(),
    urineSpecimenPresent: z.boolean().optional(),
    woundCulturePresent: z.boolean().optional(),
    specimenCollectionPresent: z.boolean().optional(),
    resultsCommunicationPresent: z.boolean().optional(),
    // Lab specimen collection
    orderingPhysician: z.string().optional(),
    labOrderDate: z.string().optional(),
    requisitionNumber: z.string().optional(),
    labReceiving: z.string().optional(),
    specimenPickup: z.string().optional(),
    pickupTimeAndCourier: z.string().optional(),
    // Results & communication
    resultsRecipients: z.array(z.string()).optional(),
    resultsExpectedTurnaround: z.string().optional(),
    resultsPriorReviewed: z.string().optional(),
    resultsClinicalNarrative: z.string().optional(),
    // Wound culture
    woundCultureTypes: z.array(z.string()).optional(),
    woundSiteCultured: z.string().optional(),
    woundBedAppearance: z.array(z.string()).optional(),
    woundCultureReason: z.string().optional(),
    // Urine specimen
    urineTestsOrdered: z.array(z.string()).optional(),
    urineCollectionMethod: z.string().optional(),
    urineSpecimenColor: z.string().optional(),
    urineOdor: z.string().optional(),
    urineVolumeAdequacy: z.string().optional(),
    urineDipstickResults: z.string().optional(),
    urinePatientSymptoms: z.array(z.string()).optional(),
    urineDisposal: z.array(z.string()).optional(),
    // Sputum / stool / other specimen
    specimenTypes: z.array(z.string()).optional(),
    specimenCustomType: z.string().optional(),
    specimenCollectionNotes: z.string().optional(),
    // Blood draw
    bloodDrawTestsOrdered: z.array(z.string()).optional(),
    bloodDrawCustomTest: z.string().optional(),
    bloodDrawTubesCollected: z.array(z.string()).optional(),
    bloodDrawSiteAccessed: z.string().optional(),
    bloodDrawNeedleGauge: z.string().optional(),
    bloodDrawAttempts: z.string().optional(),
    bloodDrawDifficultAccess: z.array(z.string()).optional(),
    bloodDrawPatientTolerance: z.string().optional(),
    bloodDrawSiteCondition: z.string().optional(),
    bloodDrawSpecimenIntegrity: z.string().optional(),
    bloodDrawSharpsDisposal: z.array(z.string()).optional(),
    bloodDrawSpecimenLabeling: z.array(z.string()).optional(),
});
